export const PROXY_BID_EVENT_NAME = 'bidAuction';
export const VIEWS_AUCTION_EVENT_NAME = 'viewAuction';
export const VIEWS_BIN_EVENT_NAME = 'viewBIN';
export const OFFERS_BIN_EVENT_NAME = 'offerBIN';
export const PURCHASES_BIN_EVENT_NAME = 'purchaseBIN';
export const BOOKED_TRANSPORT_EVENT_NAME = 'bookedTransport';
export const PAGE_BIDS_ACTIVE = 'pageBidsActive';
export const PAGE_BIDS_UNDER_OFFER = 'pageBidsUnderOffer';
export const PAGE_BIDS_DIDNT_WIN = 'pageBidsDidntWin';
export const PAGE_PURCHASES_COMPLETED = 'pagePurchasesCompleted';
export const PAGE_PURCHASES_CANCELLED = 'pagePurchasesCancelled';
export const PAGE_WALLET = 'pageWallet';
export const PAGE_AUCTION = 'pageAuction';
export const PAGE_BUY_IT_NOW = 'pageBuyItNow';
export const PAGE_SHORTLIST = 'pageShortlist';
export const PAGE_VEHICLE_PAYMENT_CONFIRMATION = 'pageVehiclePaymentConfirmation';
export const PAGE_MOTORWAY_PAY = 'pageMotorwayPay';
export const PAGE_MOTORWAY_TRADE = 'pageMotorwayTrade';
export const JOIN_MOTORWAY_PAY_CTA_EVENT_NAME = 'pageMotorwayPayClickJoinMWPay';
export const REQUEST_CALL_MOTORWAY_PAY_EVENT_NAME = 'pageMotorwayPayClickRequestCallBack';
export const PAGE_MOTORWAY_MOVE = 'pageMotorwayMove';
export const PAGE_MOTORWAY_MOVE_CLICK_BOOK_DELIVERY = 'pageMotorwayMoveClickBookDelivery';
export const PAGE_INSIGHTS = 'pageInsights';
export const INSIGHTS_SEARCH = 'pageInsightsClickSearch';
export const KYC_FORM_SUBMITTED_EVENT_NAME = 'kycFormSubmitted';
